$(document).ready(function(){
  
  $('.x-button').click(function() {
    $('.cart-popup-side').removeClass('open');
    $('body').removeClass('cartpopupopen');
  });

  $(".size-chart-popup-button").click(function() {
    $(".size-chart-popup").addClass('active');
  });
  $(".size-chart-popup-close").click(function() {
    $(".size-chart-popup").removeClass('active');
  });
  $(".size-chart-popup").click(function() {
    $(".size-chart-popup").removeClass('active');
  });
  $(".size-chart-popup-body").click(function(e) {
    e.stopPropagation();
  });
  
  
  
  $('#nav-icon').click(function() {
    $(this).toggleClass('open');
    $('.home-mobile-menu').slideToggle();
  });
  
  $('.single-product-main-info .right .product-form form .product-form__controls-group .product-form__item .sizes .sizes-single input').click(function() {
    console.log('hi');
  	$('.single-product-main-info .right .product-form form .product-form__controls-group .product-form__item .sizes .sizes-single label').removeClass('active');
    $(this).parent().find('label').addClass('active');
    var selected_size_id = $(this).attr('for');
    $('input[name="size"]').each(function() {
      if($(this).attr('id') == selected_size_id) {
      	$(this).attr('checked', true);
        $(this).addClass('active');
      } else {
      	$(this).attr('checked', false);
        $(this).removeClass('active');
      }
    });
  });
  
  $('.single-product-main-info .right .product-form form .product-form__controls-group .product-form__item .colors .colors-single input').click(function() {
  	$('.single-product-main-info .right .product-form form .product-form__controls-group .product-form__item .colors .colors-single label').removeClass('active');
    $(this).parent().find('label').addClass('active');
    var selected_color_id = $(this).parent().find('label').attr('for');
    var selected_color = $(this).parent().find('label').attr('data-color');
    $('input[name="color"]').each(function() {
      if($(this).attr('id') == selected_color_id) {
      	$(this).attr('checked', true);
        $(this).addClass('active');
        $('.single-product-main-info .right .product-form form .product-form__controls-group .product-form__item label[for="SingleOptionSelector-1"] span').text($(this).val());
      } else {
      	$(this).attr('checked', false);
        $(this).removeClass('active');

      }
    });

    if($('.single-product-main-info .product-images-single[data-color="'.concat(selected_color).concat('"]')).length > 0) {
      $('.single-product-main-info .left .product-images .product-images-single').each(function() {        
          if($(this).attr('data-color') == selected_color) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }                        
      });
    }

    else {
      console.log($('.single-product-main-info .row .product-images-single:first-of-type'))
      var new_colour = $('.single-product-main-info .row .product-images-single:first-of-type').attr('data-color')


      $('.single-product-main-info .left .product-images .product-images-single').each(function() {        
        if($(this).attr('data-color') == new_colour) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }                        
      });
    }
  });
  
  var home_content_main_slider = $('.homepage-banner-block .content-slider .single-contentslider .content-main.owl-carousel');
  var home_right_slider = $('.homepage-banner-block .right-slider.owl-carousel'); 
  var home_left_slider = $('.homepage-banner-block .left-slider.owl-carousel'); 
  home_content_main_slider.owlCarousel({
    items: 1,
    slideBy: 1,
    nav: false,
    dots: true,
    loop: true,
    autoHeight: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut'
  });
  home_right_slider.owlCarousel({
    items: 1,
    slideBy: 1,
    nav: false,
    dots: false,
    touchDrag: false,
    mouseDrag: false,
    loop: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut'
  });
  home_left_slider.owlCarousel({
    items: 1,
    slideBy: 1,
    nav: false,
    dots: false,
    touchDrag: false,
    mouseDrag: false,
    loop: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut'
  });
  home_content_main_slider.on('changed.owl.carousel', function(event) {
    home_right_slider.trigger('next.owl.carousel');
    home_left_slider.trigger('next.owl.carousel');
  });
  
  $('.bestsellers-category-slider.owl-carousel').owlCarousel({
    items: 4,
    slideBy: 1,
    nav: true,
    navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
    dots: false,
    lazyLoad: true,
    loop: false,
    responsiveClass:true,
    responsive:{
      0: {
        items: 1
      },
      767: {
        items: 2
      },
      1000: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
  
  $('.tagsSlider.owl-carousel').owlCarousel({
    items: 5,
    slideBy: 1,
    nav: true,
    navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
    dots: false,
    lazyLoad: true,
    loop: false,
    responsiveClass:true,
    responsive:{
      0: {
        items: 2
      },
      767: {
        items: 3
      },
      1000: {
        items: 4
      },
      1200: {
        items: 5
      },
      1500: {
        items: 6
      }
    }
  });
  
  $('.homepage-bestsellers-block .title-block div ul li').click(function() {
  	$('.homepage-bestsellers-block .title-block div ul li').removeClass('active');
    $(this).addClass('active');
    if($(this).attr('id') == "women") {
      $('.homepage-bestsellers-block .bestsellers-category-sliders #women').show()
      $('.homepage-bestsellers-block .bestsellers-category-sliders #men').hide()
     
    } else {
      
      $('.homepage-bestsellers-block .bestsellers-category-sliders #men').show();
      $('.homepage-bestsellers-block .bestsellers-category-sliders #women').hide();
    }
    
    
    
    /*
    
    if($(this).attr('id') == "men") {
      $('.homepage-bestsellers-block .bestsellers-category-sliders #men').show();
      $('.homepage-bestsellers-block .bestsellers-category-sliders #women').hide();
    } else {
      $('.homepage-bestsellers-block .bestsellers-category-sliders #women').show()
      $('.homepage-bestsellers-block .bestsellers-category-sliders #men').hide()
    }
    
    */
    
  });

  $('.accordian_block .mblock .link').click(function() {
    var id = $(this).attr('id');
    if($(this).hasClass('active')) {
    } else {
      $('.faqPage .icon').removeClass('open-state');
      $(this).find('.icon').addClass('open-state');
      $('.accordian_block .mblock .link').removeClass('active');
      $(this).addClass('active');
      $('.accordian_block .mblock .content').each(function() {
        if($(this).attr('id') == id) {
          $(this).slideDown();
        } else {
          $(this).slideUp();
        }
      });
    }
  });
  
  $('#to_top').on("click",function() {
    $('html, body').animate({ scrollTop: 0 }, 'slow', function () {
    });
  });
  
  $('.custom-collection-template .left .tag-filters .colours .stitle').click(function() {    
    if($(this).find('i').hasClass('fa-chevron-up')) {
      $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      $('.custom-collection-template .left .tag-filters .color_list').slideUp();
    } else {
      $(this).find('i').addClass('fa-chevron-up').removeClass('fa-chevron-down');
      $('.custom-collection-template .left .tag-filters .sizes .stitle').find('i').addClass('fa-chevron-down').removeClass('fa-chevron-up');
      $('.custom-collection-template .left .tag-filters .color_list').slideDown();
      $('.custom-collection-template .left .tag-filters .sizes_list').slideUp();
    }
  });
  
  $('.custom-collection-template .left .tag-filters .sizes .stitle').click(function() {
    if($(this).find('i').hasClass('fa-chevron-up')) {
      $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      $('.custom-collection-template .left .tag-filters .sizes_list').slideUp();
    } else {
      $(this).find('i').addClass('fa-chevron-up').removeClass('fa-chevron-down');
      $('.custom-collection-template .left .tag-filters .colours .stitle').find('i').addClass('fa-chevron-down').removeClass('fa-chevron-up');
      $('.custom-collection-template .left .tag-filters .sizes_list').slideDown();
      $('.custom-collection-template .left .tag-filters .color_list').slideUp();
    }
  });
  
  $('.custom-collection-template .left .tag-filters .color_list li').click(function() {
    
    $('html, body').animate({
      scrollTop: $(".custom-collection-template .right").offset().top
    });
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }
    var allcolorsandsizes = [];
    $('.custom-collection-template .left .tag-filters .color_list li.active').each(function() {
      allcolorsandsizes.push($(this).attr('data-val'));
    });
    $('.custom-collection-template .left .tag-filters .size_list li.active').each(function() {
      allcolorsandsizes.push("size_" + $(this).attr('data-val'));
    });
    $('.custom-collection-template .right #Collection .mainb').each(function() {
      var hasCol = '';
      var main_block = $(this);
      var main_class = $(this).attr('class');
      $.each(allcolorsandsizes, function(i, val) {
        if(main_class.includes(val)) {
          hasCol = 'yes';
        }
      });
      if(hasCol != "") {
      	$(this).show();
      } else {
      	$(this).hide();
      }
    });
    if($('.custom-collection-template .left .tag-filters .color_list li.active').length == 0 && $('.custom-collection-template .left .tag-filters .size_list li.active').length == 0) {
      $('.custom-collection-template .right #Collection .mainb').each(function() {
        $(this).show();
      });
    }
  });
  
  $('.custom-collection-template .left .tag-filters .size_list li').click(function() {
    $('html, body').animate({
      scrollTop: $(".custom-collection-template .right").offset().top
    });
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }
    var allcolorsandsizes = [];
    $('.custom-collection-template .left .tag-filters .color_list li.active').each(function() {
      allcolorsandsizes.push($(this).attr('data-val'));
    });
    $('.custom-collection-template .left .tag-filters .size_list li.active').each(function() {
      allcolorsandsizes.push("size_" + $(this).attr('data-val'));
    });
    $('.custom-collection-template .right #Collection .mainb').each(function() {
      var hasCol = '';
      var main_block = $(this);
      var main_class = $(this).attr('class');
      $.each(allcolorsandsizes, function(i, val) {
        if(main_class.includes(val)) {
          hasCol = 'yes';
        }
      });
      if(hasCol != "") {
      	$(this).show();
      } else {
      	$(this).hide();
      }
    });
    if($('.custom-collection-template .left .tag-filters .color_list li.active').length == 0 && $('.custom-collection-template .left .tag-filters .size_list li.active').length == 0) {
      $('.custom-collection-template .right #Collection .mainb').each(function() {
        $(this).show();
      });
    }
  });
  
  $('.custom-collection-template .left .tag-filters .title').click(function() {
  	$('.custom-collection-template .left .tag-filters .colours').slideToggle();
    $('.custom-collection-template .left .tag-filters .sizes').slideToggle();
  });

  $('.linkFace, .linkStethoscopes, .linkChef, .linkWork, .linkContact').mouseenter(function() {
  	$('.women_sub_menu').fadeOut();
    $('.men_sub_menu').fadeOut();
  });
  
  $('.site-header .mainMenu ul li a.otherLink.linkWomen').mouseenter(function() {
  	$('.women_sub_menu').fadeIn();
    $('.men_sub_menu').fadeOut();
  });
  
  $('.site-header .mainMenu ul li a.otherLink.linkMen').mouseenter(function() {
  	$('.men_sub_menu').fadeIn();
    $('.women_sub_menu').fadeOut();
  });
  
  $('.womenmen').mouseleave(function() {
  	$('.women_sub_menu').fadeOut();
    $('.men_sub_menu').fadeOut();
  });
  
  // Load More Button
  $('.js-load-more').on('click', function(){
    var $this = $(this);
    var totalPages = parseInt($('[data-total-pages]').val());
    var currentPage = parseInt($('[data-current-page]').val()) + 1;
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('#Collection').append($(responseHTML).find('#Collection').html());
      },
      complete: function() {
        if(currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
          if(currentPage == totalPages) {
            var totalNum = $('#totalPrNumber').attr('data-total');
            console.log(totalNum);
            $('#totalPrNumber span.num').text(totalNum);
          } else {
            var num = parseInt($('#totalPrNumber span.num').text()) + 24;
            $('#totalPrNumber span.num').text(num);
          }
        }
        if(currentPage == totalPages) {
          $('.load-more_wrap button').hide();
        }
      }
    })
  });
  
  /*$(".powered-link").hide();*/
  $(".powered-link").css("display","none !important");

  /*Home Page  only - 7th August 2025 */
  if (window.location.pathname === "/") {
  //Hide Sale Badge from  Home Page    
    $(".price__badges").hide();

     // If you want to override CSS and force another display, e.g. 'block':
      $('div.single-product-block .product__price').each(function() {        
         $(this).css('display', 'block');
        });
        
     // Giving color to regular price if it is in SALE
      /*  $('div.single-product-block .product__price .price__sale s').each(function() {
           $(this).css('color', '#9d0b35');
        }); 
      */

    }
// Provide Color to regular price if it is in SALE
        $('div.single-product-block .product__price .price__sale s').each(function() {
           $(this).css('color', '#9d0b35');
        });
  
});